export const TRIVIA_CONTINUE_KEYS = ["Enter", "ArrowRight"];
export const TRIVIA_CONTINUE_HOTKEY_HINT = "Enter · →";
export const TRIVIA_FEEDBACK_SAFE_PADDING_BOTTOM =
  "max(16px, calc(12px + env(safe-area-inset-bottom, 0px)))";

const TYPING_TAGS = new Set(["INPUT", "TEXTAREA", "SELECT"]);

export function canContinueTriviaFeedback({
  phase,
  onSkipFeedback,
  dialogOpen = false,
} = {}) {
  return (
    phase === "feedback" &&
    typeof onSkipFeedback === "function" &&
    !dialogOpen
  );
}

export function isTriviaHotkeyTypingTarget(target) {
  if (!target) return false;
  if (TYPING_TAGS.has(target.tagName)) return true;
  return Boolean(target.isContentEditable);
}

export function shouldHandleTriviaContinueKey(event, canContinue) {
  if (!canContinue) return false;
  if (!event || !TRIVIA_CONTINUE_KEYS.includes(event.key)) return false;
  if (isTriviaHotkeyTypingTarget(event.target)) return false;
  if (event.key === "Enter" && event.target?.tagName === "BUTTON") return false;
  return true;
}
